import { createFileRoute } from "@tanstack/react-router";
import Vsl from "../pages/Vsl";

export const Route = createFileRoute("/vsl")({
  component: Vsl,
});
